var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLapsedCustomerSolid = function SvgLapsedCustomerSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm0 4.25a.5.5 0 0 1 .447.276l1.386 2.773 2.75.458a.5.5 0 0 1 .27.847l-1.823 1.823.465 3.252a.5.5 0 0 1-.719.518L12 15.06l-2.776 1.388a.5.5 0 0 1-.719-.518l.465-3.252-1.824-1.823a.5.5 0 0 1 .272-.847l2.749-.458 1.386-2.773A.5.5 0 0 1 12 6.5Z",
    fill: "currentColor"
  })));
};
export default SvgLapsedCustomerSolid;